<script lang="ts">
  import type { ActivityTypes } from '$src/types/events';

  let { value = $bindable(['']) }: { value: string[] } = $props();
  let values: string[] = $state(value);
  const tags: ActivityTypes = window.activityTypes;

  const manageTags = (slug: string) => {
    if (slug && !values.includes(slug)) {
      values = values.filter((tag) => tag !== '');
      values.push(slug);
    } else if (slug) {
      values = values.filter((tag) => tag !== slug);
    } else if (slug === '') {
      values = [''];
    }

    if (!values.length) {
      values = [''];
    }

    value = values;
  };
</script>

<div class="flex flex-wrap gap-3">
  {#each tags as tag}
    <button
      type="button"
      data-active={value.includes(tag.slug)}
      class="2xl:fluid-text-[13] 2xl:fluid-px-[12] 2xl:fluid-py-[9] border-black-1000 border-1 px-[12px] py-[9px] text-[0.8125rem] leading-[90%] font-medium transition"
      onclick={() => {
        manageTags(tag.slug);
      }}
    >
      <span class="flex h-[1cap]">{tag.title}</span>
    </button>
  {/each}
</div>

<style>
  [data-active='true'] {
    color: var(--color-primary);
    background-color: var(--color-black-1000);
  }
</style>
